export default "__VITE_ASSET__Dke_vVR2__"